import React, { useEffect } from "react"
import { View } from "react-native"
import styles from "./styles"
import { OpenSansText } from "@Components/CustomText/OpenSansText"
import { baseFontFamily } from "@Constants/baseStyles"
import { BreeSerifText } from "@Components/CustomText/BreeSerifText"
import SavoirsTopTabStack from "@Navigation/TopTabBarStack/SavoirsTopTabStack/SavoirsTopTabStack"
import { useConclusionHooks } from "../../../Hooks/useConclusionHooks"

const Savoirs = () => {
    const { handleFetchConclusion } = useConclusionHooks()

    useEffect(() => {
        handleFetchConclusion()
    }, [])

    return (
        <View style={styles.container}>
            <View style={styles.header}>
                <BreeSerifText style={styles.headerTile} fontSize={24}>
                    Savoir
                </BreeSerifText>
                <OpenSansText defaultFontFamily={baseFontFamily.OpenSansSemiBold} fontSize={16}>
                    Retrouvez ici des articles et vidéos réalisés par l'équipe d'IVEHTE.
                </OpenSansText>
            </View>
            <SavoirsTopTabStack />
        </View>
    )
}

export default Savoirs
